import React from 'react';

const WarningRemoveAllCartIcon = ({ width, height }: { width: number; height: number }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 48 48" fill="none">
      <path
        d="M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z"
        fill="#E56910"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.9996 27C23.116 27 22.3996 26.2837 22.3996 25.4L22.3996 14.4C22.3996 13.5163 23.116 12.8 23.9996 12.8C24.8833 12.8 25.5996 13.5163 25.5996 14.4L25.5996 25.4C25.5996 26.2837 24.8833 27 23.9996 27Z"
        fill="white"
      />
      <circle cx="24" cy="32.5" r="2.5" transform="rotate(-180 24 32.5)" fill="white" />
    </svg>
  );
};

export default WarningRemoveAllCartIcon;
